import loadable from "@loadable/component";
import { LinkedInCallback } from "react-linkedin-login-oauth2";
import Pages from "./pages.jsx";
import UserRoles from "../utility/user-role";

// Common
const Dashboard = loadable(() => import("../pages/dashboard/index.jsx"));
const Calendar = loadable(() => import("../pages/calendar/index.jsx"));
const Marketplace = loadable(() => import("../pages/marketplace/index.jsx"));
const Chat = loadable(() => import("../pages/chat/index.jsx"));
const Tips = loadable(() => import("../pages/tips/index.jsx"));
const NotFound = loadable(() => import("../pages/not-found.jsx"));

// For service providers and agents hack
const LoginPageHack = loadable(() => import("../pages/login-hack/index.jsx"));
const SignUpPageHack = loadable(() => import("../pages/landing-page-qld-event/index.jsx"));

// Agent
const AgentLandingPage = loadable(() => import("../pages/landing-page/index.jsx"));
const ConnectedCustomers = loadable(() => import("../pages/connected-customers/index.jsx"));
// Business
const BusinessLandingPage = loadable(() => import("../pages/landing-page/index.jsx"));
const BusinessProfilePage = loadable(() => import("../pages/business-profile/business-user-settings.jsx"));
const BusinessUserSettings = loadable(() => import("../pages/business-profile/index.jsx"));
const Jobs = loadable(() => import("../pages/jobs/index.jsx"));

// Customer
const CustomerLandingPage = loadable(() => import("../pages/landing-page-customer/index.jsx"));
const Favorites = loadable(() => import("../pages/favorites/index.jsx"));
const MyProperties = loadable(() => import("../pages/my-properties/index.jsx"));
const Tasks = loadable(() => import("../pages/tasks/index.jsx"));
const MyCommunity = loadable(() => import("../pages/my-community/index.jsx"));
const Coaching = loadable(() => import("../pages/coaching/index.jsx"));

export default function configureRoutes() {
  const routes = [];

  if (process.env.USER_ROLE === UserRoles.Customer || process.env.NODE_ENV === "production") {
    const consumer = [{
      accessible: true,
      component: CustomerLandingPage,
      exact: true,
      path: "/",
      title: "Bemoved",
      type: "public",
    },
    {
      accessible: true,
      component: Tasks,
      exact: true,
      path: "/tasks",
      title: "Tasks",
      type: "private",
    }, {
      accessible: true,
      component: MyCommunity,
      exact: true,
      path: "/my-community",
      title: "My Community",
      type: "private",
    }, {
      accessible: true,
      component: Favorites,
      exact: true,
      path: "/favorites",
      title: "Favorites",
      type: "private",
    }, {
      accessible: true,
      component: Calendar,
      exact: true,
      path: "/calendar",
      title: "Calendar",
      type: "private",
    }, {
      accessible: true,
      component: MyProperties,
      exact: true,
      path: "/my-properties",
      title: "My Properties",
      type: "private",
    }];

    routes.push(...consumer);
  }

  if (process.env.USER_ROLE === UserRoles.ServiceProvider || process.env.NODE_ENV === "production") {
    const business = [{
      accessible: true,
      component: BusinessLandingPage,
      exact: true,
      path: process.env.NODE_ENV === "production" ? Pages.BusinessLandingPage : "/",
      title: "Bemoved",
      type: "public",
    }, {
      accessible: true,
      component: BusinessUserSettings,
      exact: true,
      path: "/business-user-settings",
      title: "User Settings",
      type: "private",
    },
    {
      accessible: true,
      component: Calendar,
      exact: true,
      path: "/calendar",
      title: "Calendar",
      type: "private",
    },
    {
      accessible: true,
      component: Jobs,
      exact: true,
      path: "/jobs",
      title: "Jobs",
      type: "private",
    }, {
      accessible: true,
      component: BusinessProfilePage,
      exact: true,
      path: Pages.Profile,
      title: "User Profile",
      type: "private",
    }, {
      accessible: true,
      component: SignUpPageHack,
      exact: true,
      path: "/business/signup",
      title: "Business sign-up",
      type: "public",
    }];

    routes.push(...business);
  }

  if (process.env.USER_ROLE === UserRoles.Agent || process.env.NODE_ENV === "production") {
    const agent = [{
      accessible: true,
      component: AgentLandingPage,
      exact: true,
      path: process.env.NODE_ENV === "production" ? Pages.AgentLandingPage : "/",
      title: "Bemoved",
      type: "public",
    }, {
      accessible: true,
      component: ConnectedCustomers,
      exact: true,
      path: "/referrals",
      title: "Connected Customers",
      type: "private",
    }, {
      accessible: true,
      component: LoginPageHack,
      exact: true,
      path: "/login",
      title: "Login",
      type: "public",
    }, {
      accessible: true,
      component: SignUpPageHack,
      exact: true,
      path: "/agent/signup",
      title: "Agent sign-up",
      type: "public",
    }];

    routes.push(...agent);
  }

  return [...routes, {
    accessible: true,
    component: LinkedInCallback,
    exact: true,
    path: "/linkedin-callback",
    title: "Linkedin callback",
    type: "public",
  },
  {
    accessible: true,
    component: Dashboard,
    exact: true,
    path: "/home",
    title: "Dashboard",
    type: "private",
  },
  {
    accessible: true,
    component: Chat,
    exact: true,
    path: "/chat/:publicId?",
    title: "Chat",
    type: "private",
  },
  {
    accessible: true,
    component: Marketplace,
    exact: true,
    path: "/marketplace",
    title: "Marketplace",
    type: "private",
  },
  {
    accessible: true,
    component: Tips,
    exact: true,
    path: "/tips",
    title: "Guides, Tips & Hacks",
    type: "private",
  },
  {
    accessible: true,
    component: Coaching,
    exact: true,
    path: "/coaching",
    title: "Coaching cards",
    type: "private",
  },
  {
    accessible: true,
    component: NotFound,
    exact: true,
    path: "/*",
    title: "404 Not Found",
    type: "public",
  }];
}
